import { useState } from 'react';

interface UseToggleSetResult {
  readonly selected: ReadonlySet<string>;
  readonly toggle: (value: string) => void;
}

/** 체크박스·칩 다중 선택용 Set 토글 상태 — 카탈로그 섹션들이 공유한다. */
export const useToggleSet = (initial: Iterable<string>): UseToggleSetResult => {
  const [selected, setSelected] = useState<ReadonlySet<string>>(() => new Set(initial));

  const toggle = (value: string): void => {
    setSelected((current) => {
      const next = new Set(current);

      if (next.has(value)) {
        next.delete(value);
      } else {
        next.add(value);
      }

      return next;
    });
  };

  return { selected, toggle };
};
